import db from "@/plugins/dexie"
import moment from "moment-timezone";
import dadosTabelas from "./local/tabelas"
import apivarejoweb from '@/services/api-varejoweb';
import store from '@/store/index';
import { converterDataApiParaLocal } from '@/utils/geradata';
// import $_enviaPrestacaoServico from "./local/enviaCadastro";
// import $_enviaColeta from "./local/enviaColeta";
/* function getSessionStorage(key, defaultValue) {
    return sessionStorage.getItem(key) ?? defaultValue;
} */
export default async function $_atualizaLocal() {
    if (!navigator.onLine) {
        console.log('Sem conexão com a internet. Sincronização cancelada.');
        store.dispatch('atualizalocal/primeiroUpdate', false);
        return;
    }

    const tokenString = sessionStorage.getItem('auth:token');
    if (!tokenString || tokenString === 'undefined' || tokenString === 'null') {
        console.warn('Sincronização cancelada: Token de autenticação não encontrado.');
        store.dispatch('atualizalocal/primeiroUpdate', false);
        return;
    }

    console.log('=>>>');
    store.dispatch('atualizalocal/updateProcessados', 0);
    store.dispatch('atualizalocal/updateTotal', 0);
    const info = dadosTabelas();
    const cache = store.getters['cache/arraydata'];
    let arrayDataAtualizacao;
    if (!cache.length) {
        arrayDataAtualizacao = await Promise.all(Object.entries(info).map(async ([ nome, dados ]) => {
        if (nome === 'ordemservico' || nome === 'ordemservicoitem') {
            return null;
        }
        const count = await db[nome].count();
        const dataatt = await db[nome].orderBy(dados.campoatt).filter(item => item[dados.campoatt] !== null).last();
        let dataattFinal = dataatt?.[dados.campoatt] || '1997-01-01 13:00:00';
        
        if (nome === 'produto' && count < 8000) {
            console.log(`[atualizalocal] Tabela produto possui ${count} registros (menos que o total). Forçando busca desde 1997 para trazer todos os produtos.`);
            dataattFinal = '1997-01-01 13:00:00';
        }

        let idsLocais = null;
        if (nome === 'prestacaoservico' || nome === 'prestacaoservicoitem') {
            const registros = await db[nome].toArray();
            idsLocais = registros.map(r => r[`${dados.prefixo}idnuvem`]).filter(id => id != null);
        }
        console.log(dados.nomeapi || nome, 'data', dataattFinal,  converterDataApiParaLocal(dataattFinal));
        let dataFormatada = '1997-01-01 13:00:00.000';
        const dt = converterDataApiParaLocal(dataattFinal);
        if (dt) {
            dataFormatada = dt;
        }
        return {
            tabela: dados.nomeapi || nome,
            tabelaApp: nome,
            data: dataFormatada,
            ids: idsLocais
        };
    }));
    
        arrayDataAtualizacao = arrayDataAtualizacao.filter(item => item !== null);
        store.commit('cache/SET_CACHE_ARRAYDATA', arrayDataAtualizacao);
    } else {
        arrayDataAtualizacao = store.getters['cache/arraydata'];
        for (let ar of arrayDataAtualizacao) {
            if (ar.tabelaApp === 'produto') {
                const count = await db.produto.count();
                if (count < 8000) {
                    console.log(`[atualizalocal] Tabela produto no Dexie possui ${count} registros. Resetando data para 1997 para trazer a lista completa.`);
                    ar.data = '1997-01-01 13:00:00.000';
                }
            }
            if (ar.tabelaApp === 'prestacaoservico' || ar.tabelaApp === 'prestacaoservicoitem') {
                const dados = info[ar.tabelaApp];
                if (dados) {
                    const registros = await db[ar.tabelaApp].toArray();
                    ar.ids = registros.map(r => r[`${dados.prefixo}idnuvem`]).filter(id => id != null);
                }
            }
        }
        arrayDataAtualizacao = arrayDataAtualizacao.map(ar => {
            if (ar.data === 'Invalid date' || !moment(ar.data).isValid()) {
                return { ...ar, data: '1997-01-01 13:00:00.000' };
            }
            return ar;
        });
        arrayDataAtualizacao.forEach((ar) => console.log('Tabela: ', ar.tabela, 'Data: ', ar.data));
    }
    if (arrayDataAtualizacao.every(item => item.data.startsWith("1997-01-01"))) {
      store.dispatch('atualizalocal/primeiroUpdate', true);
      store.dispatch('cache/primeiroUpdate', true);
    }
    try {
        const retorno = await apivarejoweb.post(`all/itemsaatualizar`, arrayDataAtualizacao);
        console.log('<<<=');
        
        $_geraTotal(retorno.data);
        
        retorno.data.forEach((item) => {
            $_geraLog(item);
            $_manipulaTabela(item, info);
        });
    } catch (error) {
        console.warn('Erro ao atualizar dados locais (sem internet ou servidor offline):', error);
    } finally {
        store.dispatch('atualizalocal/primeiroUpdate', false);
    }
}
// eslint-disable-next-line no-unused-vars
async function $_geraLog({ data, tabela }) {
    console.log('%cTabela: ' + tabela, 'font-weight: bold; border-top: 1px solid #fff; padding-top: 3px')
    console.log('%c' + (data ? data.length : 0) + '%c itens para criação ou atualização', 'color: ' +
        (data && data.length > 0 ? '#f65' : '#5cc'), 'color: #fff');
}
// eslint-disable-next-line no-unused-vars
async function $_manipulaTabela({ data, tabela }, info) {
    if (!data) return;
    let idnuvem = await db[tabela].toArray();
    let idLocal = idnuvem.reduce((ids, item) => {
      const key = String(item[`${info[tabela].prefixo}idnuvem`]);
      const value = item.id;
      ids[key] = value;
      return ids;
    }, {});
    idnuvem = idnuvem.map((item) => String(item[`${info[tabela].prefixo}idnuvem`]));
    idnuvem = idnuvem.filter((item) => item !== "undefined" && item !== "null" && item !== "");
    await $_deletaLocal(idnuvem, tabela, info);
    if (!idnuvem) { idnuvem = []; }
    
    if (tabela === 'veiculo') {
      const todosVeiculos = await db.veiculo.toArray();
      const vistos = new Map();
      const idsParaDeletar = [];
      for (const v of todosVeiculos) {
        const chave = v.veiidveiculo || v.veiidnuvem || (v.veiplaca ? String(v.veiplaca).trim().toUpperCase() : null);
        if (chave) {
          if (vistos.has(chave)) {
            idsParaDeletar.push(v.id);
          } else {
            vistos.set(chave, v.id);
          }
        }
      }
      if (idsParaDeletar.length > 0) {
        await db.veiculo.bulkDelete(idsParaDeletar);
        let idnuvemNovo = await db.veiculo.toArray();
        idLocal = idnuvemNovo.reduce((ids, item) => {
          const key = String(item[`${info[tabela].prefixo}idnuvem`]);
          const value = item.id;
          ids[key] = value;
          return ids;
        }, {});
        idnuvem = idnuvemNovo.map((item) => String(item[`${info[tabela].prefixo}idnuvem`])).filter((item) => item !== "undefined" && item !== "null" && item !== "");
      }
    }

    if (tabela === 'marcaveiculo') {
      const todosMarcas = await db.marcaveiculo.toArray();
      const vistos = new Map();
      const idsParaDeletar = [];
      for (const m of todosMarcas) {
        const chave = m.mavidnuvem || m.mavidmarcaveiculo || m.id;
        if (chave) {
          if (vistos.has(chave)) {
            idsParaDeletar.push(m.id);
          } else {
            vistos.set(chave, m.id);
          }
        }
      }
      if (idsParaDeletar.length > 0) {
        await db.marcaveiculo.bulkDelete(idsParaDeletar);
        let idnuvemNovo = await db.marcaveiculo.toArray();
        idLocal = idnuvemNovo.reduce((ids, item) => {
          const key = String(item[`${info[tabela].prefixo}idnuvem`] || item.mavidmarcaveiculo);
          const value = item.id;
          ids[key] = value;
          return ids;
        }, {});
        idnuvem = idnuvemNovo.map((item) => String(item[`${info[tabela].prefixo}idnuvem`] || item.mavidmarcaveiculo)).filter((item) => item !== "undefined" && item !== "null" && item !== "");
      }
    }
    
    const novosItens = [];
    const modificacoes = [];
    
    const totalItems = data.length;
    let processedItems = 0;
    const progressThreshold = Math.floor(totalItems * 0.01) || 1;
    let possuiUpdates = false;
    let possuiCreates = false;
    const apiIdField = info[tabela].idapi || 'id';
    const prefixoTabela = info[tabela].prefixo;
    data.forEach((item) => {
    const itemFormatado = info[tabela].model(item);
    const actualKey = Object.keys(item).find(k => k.toLowerCase() === apiIdField.toLowerCase()) || apiIdField;
    const rawId = item[actualKey] ?? itemFormatado[`${prefixoTabela}idnuvem`] ?? itemFormatado[`${prefixoTabela}id${tabela}`] ?? itemFormatado.id;
    const apiIdValue = rawId != null ? String(rawId) : "undefined";
        if (idnuvem.includes(apiIdValue)) {
            if (!possuiUpdates) {
                possuiUpdates = true;
                store.dispatch('atualizalocal/addAAtualizar', 1);
            }
            modificacoes.push({
                key: idLocal[apiIdValue],
                changes: itemFormatado
            });
        } else {
            if (!possuiCreates) {
                possuiCreates = true;
                store.dispatch('atualizalocal/addAAdicionar', 1);
            }
            novosItens.push(itemFormatado);
        }
        
        processedItems++;
        if (processedItems >= progressThreshold) {
            store.dispatch('atualizalocal/addProcessados', processedItems);
            processedItems = 0;
        }
    });
    if (processedItems > 0) {
        store.dispatch('atualizalocal/addProcessados', processedItems);
    }
    if (modificacoes.length > 0) {
        try {
            await db[tabela].bulkUpdate(modificacoes);
            const [dataalteracao] = Object.keys(modificacoes[0]?.changes || {}).filter((item) => item.includes('dataalteracao'));
            if(dataalteracao) {
                const ultimaDataAlteracao = modificacoes
                .map((obj) => obj.changes)
                .sort((a, b) => new Date(b[dataalteracao]) - new Date(a[dataalteracao]))
                .shift()[dataalteracao]
                
                const dt = converterDataApiParaLocal(ultimaDataAlteracao);
                if (dt) {
                    store.dispatch('cache/atualizaData', { data: dt, tabela });
                }
            }
      
            store.dispatch('atualizalocal/addEstaAtualizado', tabela);  
            
            if (['ordemservico', 'ordemservicoitem', 'prestacaoservico', 'prestacaoservicoitem'].includes(tabela)) {
              store.dispatch('cache/reloadCache', tabela );
            } else {
              store.dispatch('cache/esvaziarCache', { tabela });
            }
        } catch (err) {
            console.error("Bulk Update Error:", err);
            store.dispatch('atualizalocal/addEstaAtualizado', { tabela, erro: err.message });
        }
    }
        
    if (novosItens.length > 0) {
        const idKey = `${prefixoTabela}idnuvem`;
        const mapaUnicos = new Map();
        for (const item of novosItens) {
            const idVal = item[idKey] ?? item.id;
            if (idVal != null) {
                mapaUnicos.set(String(idVal), item);
            } else {
                mapaUnicos.set(Symbol(), item);
            }
        }
        const novosItensUnicos = Array.from(mapaUnicos.values());

        try {
            await db[tabela].bulkAdd(novosItensUnicos, { allKeys: true });

            if (['ordemservico', 'ordemservicoitem', 'prestacaoservico', 'prestacaoservicoitem'].includes(tabela)) {
              await store.dispatch('cache/reloadCache', tabela);
            }
            
            const primeiroUpdate = store.getters['cache/primeiroUpdate'];
            if (!primeiroUpdate) {              
              const [dataalteracao] = Object.keys(novosItensUnicos[0] || {}).filter((item) => item.includes('dataalteracao'));
              if(dataalteracao) {
                  const ultimaDataAlteracao = novosItensUnicos
                    .sort((a, b) => new Date(b[dataalteracao]) - new Date(a[dataalteracao]))
                    .shift()[dataalteracao]
                  const dt = converterDataApiParaLocal(ultimaDataAlteracao);
                  if (dt) {
                      store.dispatch('cache/atualizaData', { data: dt, tabela });
                  }
              }
            }
            store.dispatch('atualizalocal/addEstaAdicionado', tabela);
        } catch (err) {
            console.error("Bulk Add Error, salvando itens individualmente:", err);
            for (const item of novosItensUnicos) {
                try {
                    await db[tabela].put(item);
                } catch (e) {
                    console.error(`Erro ao salvar item individual na tabela ${tabela}:`, e, item);
                }
            }
            store.dispatch('atualizalocal/addEstaAdicionado', { tabela, erro: err.message });
        }
    }
}
// ⚠️ Usar somente para testes
// eslint-disable-next-line no-unused-vars
async function $_manipulaTabelaComDelay({ data, tabela }, info) {
    console.log(`⚠️ Atualizando em modo TESTE`);
    
    let idnuvem = await db[tabela].toArray();
    idnuvem = idnuvem.map((item) => item[`${info[tabela].prefixo}idnuvem`]);
    await $_deletaLocal(idnuvem, tabela);
    if (!idnuvem) { idnuvem = []; }
    const novosItens = [];
    const modificacoes = [];
    const totalItems = data.length;
    let processedItems = 0;
    const progressThreshold = Math.floor(totalItems * 0.01);
    let possuiUpdates = false;
    let possuiCreates = false;
    for (let i = 0; i < totalItems; i++) {
        const item = data[i];
        const itemFormatado = info[tabela].model(item);
        if (idnuvem.includes(item.id)) {
            if (!possuiUpdates) {
                possuiUpdates = true;
                store.dispatch('atualizalocal/addAAtualizar', 1);
            }
            modificacoes.push({
                id: item.id,
                updates: itemFormatado
            });
        } else {
            if (!possuiCreates) {
                possuiCreates = true;
                store.dispatch('atualizalocal/addAAdicionar', 1);
            }
            novosItens.push(itemFormatado);
        }
        processedItems++;
        if (processedItems >= progressThreshold) {
            store.dispatch('atualizalocal/addProcessados', progressThreshold);
            processedItems = 0;
        }
        await delay(1);
    }
    if (modificacoes.length > 0) {
        try {
            await db[tabela].bulkUpdate(modificacoes);
            store.dispatch('atualizalocal/addEstaAtualizado', tabela);
        } catch (err) {
            console.error("Bulk Update Error:", err);
            store.dispatch('atualizalocal/addEstaAtualizado', { tabela, erro: err.message });
        }
    }
    if (novosItens.length > 0) {
        try {
            await db[tabela].bulkAdd(novosItens, { allKeys: true });
            store.dispatch('atualizalocal/addEstaAdicionado', tabela);
        } catch (err) {
            console.error("Bulk Add Error:", err);
            store.dispatch('atualizalocal/addEstaAdicionado', { tabela, erro: err.message });
        }
    }
}
async function $_geraTotal(data) {
    if(!data) return;
    let total = 0
    for (const tabela of data) {
        if(tabela.data) total += tabela.data.length;
    }
    store.dispatch('atualizalocal/updateTotal', total);
}
// eslint-disable-next-line no-unused-vars
async function $_deletaLocal(idnuvemlocal, tabela, info) {
    if (!idnuvemlocal || idnuvemlocal.length === 0) return;
    try {
        const response = await apivarejoweb.get(`${tabela}/idnuvem`);
        let data = response.data;
        
        if (!data || !Array.isArray(data)) {
            console.warn(`Aviso: O endpoint ${tabela}/idnuvem não retornou um array válido. Limpeza ignorada.`);
            return;
        }
        if (data.length === 0) {
            if (!['produto', 'grupo'].includes(tabela)) {
                console.warn(`⚠️ ALERTA: ${tabela}/idnuvem retornou 0 registros. Para evitar a exclusão em massa do Dexie local, o processo foi abortado.`);
            }
            return;
        }
        const apiIdField = info[tabela].idapi || 'id';
        
        const setIdsApi = new Set(data.map((item) => {
            if (typeof item === 'number' || typeof item === 'string') return String(item);
            const actualKey = Object.keys(item).find(k => k.toLowerCase() === apiIdField.toLowerCase()) || apiIdField;
            return String(item[actualKey] ?? item.idnuvem ?? item.id ?? item);
        }));
        
        let deleteIds;
        if (['produto', 'grupo'].includes(tabela)) {
            // O endpoint /idnuvem destas tabelas retorna os IDs inativos/deletados na nuvem para serem removidos do Dexie
            deleteIds = idnuvemlocal.filter(idnuvem => {
                const idStr = String(idnuvem);
                return setIdsApi.has(idStr) && idStr !== 'null';
            });
        } else {
            // O endpoint /idnuvem das demais tabelas retorna os IDs ativos na nuvem que devem permanecer no Dexie
            deleteIds = idnuvemlocal.filter(idnuvem => {
                const idStr = String(idnuvem);
                return !setIdsApi.has(idStr) && idStr !== 'null';
            });
        }
        if (deleteIds.length > 0) {
            const chunkSize = 500;
            for (let i = 0; i < deleteIds.length; i += chunkSize) {
                const chunk = deleteIds.slice(i, i + chunkSize);
                await db.transaction('rw', db[tabela], async () => {
                    await db[tabela]
                    .where(`${info[tabela].prefixo}idnuvem`)
                    .anyOf(chunk)
                    .delete();
                });
            }
            
            if (['ordemservico', 'ordemservicoitem', 'prestacaoservico', 'prestacaoservicoitem'].includes(tabela)) {
                store.dispatch('cache/reloadCache', tabela);
                return;
            }
            store.dispatch('cache/esvaziarCache', { tabela, att: info[tabela].campoatt });
        }
    } catch (error) {
        console.warn(`Aviso: Endpoint de sincronização de deleção (${tabela}/idnuvem) não encontrado ou falhou. Ignorando limpeza local.`, error.message);
    }
}
// DELAY PARA TESTES DE PERFORMANCE
function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
export async function SetupEnvioLocal({ silent = false } = {}) {
    if (navigator.onLine) {
        await $_atualizaLocal(silent);
    }
}
